import React from 'react';
import { useCustomerStatus } from 'src/features/user/lib/useCustomerStatus';

import { Price } from '../Helpers/Price';

import classes from './CreditBalance.scss';

type Props = {
    creditAvailable: number;
    creditMax: number;
};

export const CreditBalance: React.FC<Props> = React.memo(({ creditAvailable, creditMax: rawCreditMax }) => {
    const { isSignedIn } = useCustomerStatus();
    if (!isSignedIn) return null;
    // If creditMax is undefined or 0, use creditAvailable for display
    const creditMax = !rawCreditMax ? creditAvailable : rawCreditMax;
    return (
        <div className={classes.container}>
            <div className={classes.titleContainer}>
                <img className={classes.titleImage} src={require('../../../static/icons/credit.svg')} alt="" />
                <h3 className={classes.title}>Available Credit</h3>
            </div>
            <div className={classes.creditContainer}>
                <Price className={classes.creditAvailable} price={creditAvailable} priceIncl={creditAvailable} />
                /
                <Price className={classes.creditMax} price={creditMax} priceIncl={creditMax} />
            </div>
        </div>
    );
});
